import { property, flowRight as compose } from 'lodash-es';
import { clone } from '../utils';

export const current = state => ({ ...state.signUp });

const move = compose(
  clone.shallowObjectMaybe,
  property('move'),
  current
);
const getMoveProperty = prop =>
  compose(
    property(prop),
    move
  );
const getMoveAddress = addressProp =>
  compose(
    clone.shallowObjectMaybe,
    getMoveProperty(addressProp)
  );

export const fromAddress = getMoveAddress('from_address');
export const toAddress = getMoveAddress('to_address');
export const moveDate = getMoveProperty('date');

const user = compose(
  clone.shallowObjectMaybe,
  property('user'),
  current
);

export const userFirstName = compose(
  property('first_name'),
  user
);

export const userLastName = compose(
  property('last_name'),
  user
);

export const userMiddleName = compose(
  property('middle_name'),
  user
);

export const userSuffixName = compose(
  property('suffix_name'),
  user
);

export const userPhone = compose(
  property('phone'),
  user
);

export const userEmail = compose(
  property('email'),
  user
);

const userPassword = compose(
  property('password'),
  user
);

export const isSigningUp = state => !!(userEmail(state) && userPassword(state));

export const inviteToken = compose(
  property('invite_token'),
  current
);

export const isInvited = compose(
  Boolean,
  inviteToken
);
